export default __webpack_public_path__ + "static/media/mikeSap.cee2da1a.jpg";